import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { P } from "../../../AbstractElements";
import WeatherWidgets from "./WeatherWidget";
import Clock from "react-clock";

const MobileWidgets = () => {
  const [value, setValue] = useState(new Date());
  useEffect(() => {
    const interval = setInterval(() => setValue(new Date()), 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);
  const month = ["Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
  var d = new Date();
  let dateshow = month[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear();
  return (
    <Fragment>
      <Col xl="6" sm="12" className="box-col-12 xl-100">
        <Card className="o-hidden">
          <div className="weather-widget-two">
            <CardBody>
              <Row>
                <Col xl="5" md="6">
                  <div className="mobile-clock-widget">
                    <div>
                      <Clock value={value} />
                    </div>
                    <div id="date" className="date f-24 mb-2">
                      <span>{dateshow}</span>
                    </div>
                    <P attrPara={{ className: "m-0 f-14 text-light" }}>kolkata, India</P>
                  </div>
                </Col>
                <WeatherWidgets />
              </Row>
            </CardBody>
          </div>
        </Card>
      </Col>
    </Fragment>
  );
};
export default MobileWidgets;
